import type { WhatsNewEntry } from "../types";

/**
 * Release note: code-Q&A — 小环 reads loom's own code (2026-06-27).
 * PRE-STAGED: authored and ready, but published (wired into WHATS_NEW) only at
 * FEATURE_CODE_QA go-live for the loom cohort (openspec/cyclecare-whats-new.md §6).
 */
export const codeQa: WhatsNewEntry = {
  id: "2026-06-27-code-qa",
  date: "2026-06-27",
  // Committed but published only when FEATURE_CODE_QA is on (WhatsNew gates by
  // /healthz features.codeQa) — flip the prod flag and this bell entry appears.
  flag: "codeQa",
  kicker: "发布说明",
  title: "Answers from the source",
  subtitle: "以代码为准",
  // Hero = the Tier-2 motion-graphics promo (Remotion), with its title frame as
  // the poster. Pre-staged at /whatsnew/; wired into WHATS_NEW only at go-live.
  video: "/whatsnew/code-qa-promo.mp4",
  heroImage: "/whatsnew/code-qa-promo-poster.png",
  summary:
    "小环现在能读懂织灵自己的代码——答得更准、更有据；研发问到具体位置，产品/售前售后讲给客户也有底。",
  sections: [
    {
      kind: "prose",
      md: "今天起，小环能读懂织灵自己的代码。\n\n我们相信，答案该以事实为准——不是转述。问到关于 loom 的事，它不再照手册说个大概，而是按真实的样子告诉你，并指给你看具体在哪。"
    },
    {
      kind: "scene",
      eyebrow: "给客户，讲得准",
      heading: "讲给客户的每一句，都站得住",
      copy: "小环把机制拆开，按客户听得懂的顺序讲给你——连「先讲哪层、怎么讲」的话术都备好。它讲的不是手册印象，是产品里真实的结构。",
      shot: "/whatsnew/code-qa-customer-after.png"
    },
    {
      kind: "scene",
      eyebrow: "研发，问到根上",
      heading: "定位、回源、核对，一步到位",
      copy: "小环直接告诉你在哪个文件、哪一行，还讲清它怎么和其它部分接上。想知道某个功能还有哪里用到，它一处不漏地指给你。",
      shot: "/whatsnew/code-qa-dev-after.png"
    },
    {
      kind: "pillars",
      eyebrow: "你会明显感觉到",
      heading: "同一个小环，这次说的是源头的事实",
      items: [
        { emoji: "🎯", title: "有源码作准", desc: "答案来自织灵真实的实现，不是转述；讲功能、权限、能力都站得住。" },
        { emoji: "🗣", title: "讲给客户也有底", desc: "产品 / 售前 / 售后把 loom 讲准、讲专业，小环还帮你由浅入深组织话术。" },
        { emoji: "📍", title: "研发问到根上", desc: "直接指到具体文件和那一行，谁用到、怎么实现，点开就核。" },
        { emoji: "🔄", title: "永远最新", desc: "答的始终是当下真实的实现，不会给你过时的说法。" },
        { emoji: "🧭", title: "从全貌到细节", desc: "整体怎么搭、某一处怎么做，都问得到。" }
      ]
    },
    { kind: "quote", md: "目前面向 loom 内部使用，覆盖织灵的前端与后端。" },
    { kind: "prose", md: "织灵的事，问小环就行。期待你的反馈，我们加速迭代。" }
  ]
};
